import React, { useEffect } from 'react'

import { Box, Button, Grid } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'
import * as yup from 'yup'

import {
  ContractStep,
  EvaluationStep,
  GeneralInfoStep,
  RisksStep,
  Stepper,
} from '../../../components'
import { DriveTour, LoadingFeedback } from 'components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

import constants from 'constants/index'
import theme from 'theme'
import GeneralInfoSchema from '../../../components/GeneralInfo/schema'
import ContractSchema from '../../../components/Contract/schema'
import RisksSchema from '../../../components/Risks/schema'

const CreationForm = ({ openTour, setOpenTour }) => {
  const {
    activeStep,
    isPreAvaliation,
    handleAdvanceStep,
    handleBack,
    handleReturnStep,
    wantsToAdvanceStep,
    wantsToReturnStep,
    isLoading,
  } = useThirdPartyManagementStepper()

  const EMPTY_SCHEMA = yup.object().shape({})
  const { STEPS_OBJECT } = constants.tours.thirdPartyManagements
  const tourStepsMap = isPreAvaliation
    ? [
        STEPS_OBJECT.PRE_AVALIATION.CREATION.GENERAL_INFO,
        STEPS_OBJECT.PRE_AVALIATION.CREATION.EVALUATION,
        STEPS_OBJECT.PRE_AVALIATION.CREATION.RISKS,
      ]
    : [
        STEPS_OBJECT.CREATION.GENERAL_INFO,
        STEPS_OBJECT.CREATION.EVALUATION,
        STEPS_OBJECT.CREATION.CONTRACT,
        STEPS_OBJECT.CREATION.RISKS,
      ]

  const schemas = isPreAvaliation
    ? [GeneralInfoSchema, EMPTY_SCHEMA, RisksSchema]
    : [GeneralInfoSchema, EMPTY_SCHEMA, ContractSchema, RisksSchema]

  const formMethods = useForm({
    validationSchema: schemas[activeStep],
    defaultValues: {
      name: '',
      document: '',
      international: false,
      segmentId: '',
      description: '',
      newResponsibleEmail: '',
      endDate: null,
      dateToSendEmails: null,
      hireDate: null,
      renewDate: null,
      treatmentAgentType: '',
      companyAgentType: '',
      attachments: [],
      riskLevel: 0,
      observation: '',
      simplifiedRegister: false,
      hasInternationalTransfer: false,
      internationalTransferDescription: '',
      internationalTransfers: [],
      suboperators: [],
      responsibleEmails: [],
      selectedQuestionnaires: [],
    },
  })

  const stepComponents = isPreAvaliation
    ? [<GeneralInfoStep />, <EvaluationStep />, <RisksStep />]
    : [<GeneralInfoStep />, <EvaluationStep />, <ContractStep />, <RisksStep />]

  const actionButtonText = () => {
    if (activeStep === stepComponents.length - 1) {
      return 'Finalizar'
    }

    return 'Avançar'
  }

  useEffect(() => {
    if (wantsToReturnStep) handleBack()
  }, [wantsToReturnStep])

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stepper />
        </Grid>

        <Grid item xs={12}>
          <FormContext {...formMethods}>
            {stepComponents[activeStep]}
          </FormContext>
        </Grid>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="flex-end"
            gridGap={theme.spacing(2)}
          >
            <Button variant="outlined" onClick={handleReturnStep}>
              Voltar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAdvanceStep}
              disabled={wantsToAdvanceStep}
            >
              {actionButtonText()}
            </Button>
          </Box>
        </Grid>
      </Grid>

      <DriveTour
        stepsMatrix={tourStepsMap[activeStep]}
        open={openTour}
        setOpen={setOpenTour}
      />
    </>
  )
}

export default CreationForm
